import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { ShuttelbussService } from '../../../../../../../../../app/services/shuttlebuss.service';
import { SnackbarService } from '../../../../../../../../../app/services/snackbar.service';
import { BackOfficeService } from '../../../../../../../../../app/services/backoffice.service';
import { MyConfigService } from '../../../../../../../../../app/services/my-config.service';
import { TranslocoService } from '@jsverse/transloco';
import { CartService } from '../../../../../../../../../app/parkifly-bookings/services/cart.service';

@Component({
  selector: 'app-internal-booking-summary',
  templateUrl: './internal-booking-summary.component.html',
  styleUrl: './internal-booking-summary.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InternalBookingSummaryComponent implements OnInit {
  isLoading = false;
  allOrgs: { name: string; organizationId: string }[] = [];
  locale: string = "sv";
  orderId = null;

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public userInput: any,
    public shuttleBussService: ShuttelbussService,
    public backOfficeService: BackOfficeService,
    private bottomSheetRef: MatBottomSheetRef<InternalBookingSummaryComponent>,
    public router: Router,
    public snackbar: SnackbarService,
    private myConfigService: MyConfigService,
    public translate: TranslocoService,
    private cartService: CartService
  ) {
    this.translate.langChanges$.subscribe((lang) => {
      this.locale = lang;
    });
  }

  ngOnInit(): void {
    this.orderId = this.userInput.cart.orderId;
    const organizations = this.myConfigService?.myConfig?.organizations || [];

    organizations?.forEach((org: any) => {
      this.allOrgs.push({
        name: org.config.name,
        organizationId: org.organizationId,
      });

      if (org.config.subOrganizations && Array.isArray(org.config.subOrganizations)) {
        org.config.subOrganizations.forEach((subOrg: any) => {
          this.allOrgs.push({
            name: subOrg.name,
            organizationId: subOrg.organizationId,
          });
        });
      }
    });
  }

  reset(): void {
    this.shuttleBussService.resetForm();
  }

  cancel() {
    this.bottomSheetRef.dismiss();
    if (this.orderId) {
      this.backOfficeService.setOrderstatusCancel(this.orderId, false).subscribe({
        next: (result) => {
          this.orderId = null;
        },
        error: (err) => {
          console.error('Error occurred while canceling order on edit:', err);
        }
      });
    }
  }

  sendConfirmation() {
    this.isLoading = true;
    this.backOfficeService.setOrderStatusPaidCart(this.userInput.cart.orderId, this.userInput.customPrice).subscribe(result => {
      this.bottomSheetRef.dismiss({
        customer: this.userInput.customer,
        cart: this.userInput.cart,
      });
      this.isLoading = false;
      this.snackbar.openSnackBar('Order Status Paid', 'OK');
      this.reset();
    });
  }

  getOrganizationName(orgId: string): string {
    const org = this.allOrgs.find(org => org.organizationId === orgId);
    return org ? org.name : '';
  }

}
